// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginForm_wrapper__lDSXi","header":"LoginForm_header__nyZqB","btn":"LoginForm_btn__OJeFM"};